<template>
  <VaLayout
    :left="{ fixed: true, absolute: breakpoints.mdDown, order: 1, overlay: breakpoints.mdDown && !isSidebarMinimized }"
    @leftOverlayClick="onLeftOverlayClick"
  >
    <template #left>
      <AppSidebar
        :minimized="isSidebarMinimized"
        :animated="!isMobile"
        :mobile="isMobile"
        :class="{ 'app-sidebar--collapsed-hidden': isTablet && isSidebarMinimized }"
      />
    </template>

    <template #content>
      <div :class="{ minimized: isSidebarMinimized }" class="app-layout__sidebar-wrapper">
        <div v-if="isFullScreenSidebar" class="flex justify-end">
          <VaButton class="px-4 py-4" icon="md_close" preset="plain" @click="onCloseSidebarButtonClick" />
        </div>
        <div v-else-if="isTablet && isSidebarMinimized" class="sidebar-menu-float">
          <VaButton class="px-4 py-4" icon="menu" preset="plain" @click="onOpenSidebarButtonClick" />
        </div>
      </div>
      <main class="lg:p-4 lg:pt-2">
        <article>
          <RouterView />
        </article>
      </main>
    </template>
  </VaLayout>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'
import { useBreakpoint } from 'vuestic-ui'

import { useGlobalStore } from '../stores/global-store'
import { usePermissionStore } from '../stores/permission-store'

import AppSidebar from '../components/sidebar/AppSidebar.vue'

const GlobalStore = useGlobalStore()
const PermissionStore = usePermissionStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)

const breakpoints = useBreakpoint()

const sidebarWidth = ref('16rem')
const sidebarMinimizedWidth = ref(undefined)

const isMobile = ref(false)
const isTablet = ref(false)

const onResize = () => {
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
  sidebarWidth.value = isTablet.value ? '100%' : '16rem'

  //console.log('[Resize] isMobile:', isMobile.value, 'isTablet:', isTablet.value)
}

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
  GlobalStore.scheduleTokenRefresh()
  // Nạp quyền thật (ma trận 1) khi mở/refresh app; lỗi sẽ fallback Permission.ts tĩnh
  if (!PermissionStore.isLoaded) {
    PermissionStore.loadMyPermissions()
  }
  //console.log('[Mounted] store.isSidebarMinimized =', isSidebarMinimized.value)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    GlobalStore.setSidebarMinimized(true)
    //console.log('[RouteUpdate] Force minimize sidebar on mobile')
  }
})

const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

const onCloseSidebarButtonClick = () => {
  GlobalStore.setSidebarMinimized(true)
  //console.log('[Action] Close button clicked → sidebarMinimized = true')
}

const onOpenSidebarButtonClick = () => {
  GlobalStore.setSidebarMinimized(false)
}

const onLeftOverlayClick = () => {
  GlobalStore.setSidebarMinimized(true)
  //console.log('[Action] Overlay clicked → sidebarMinimized = true')
}

// Debug: watch store changes
// watch(isSidebarMinimized, (val) => {
//   console.log('[WATCH] store.isSidebarMinimized changed →', val)
// })
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}

// Tren mobile khi sidebar dang thu gon, no phai an hoan toan (width: 0)
// Neu khong, icon/padding ben trong se tran ra ngoai va che mat ~20-30px ben trai noi dung
.va-sidebar.app-sidebar--collapsed-hidden {
  width: 0 !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

@media (max-width: 1024px) {
  .sidebar-menu-float {
    position: fixed;
    top: 6px;
    left: 6px;
    z-index: 200;
  }
}
</style>
